var map = {
	"./basketball-active.webp": 1447,
	"./basketball.webp": 1448,
	"./bg.webp": 1449,
	"./football-active.webp": 1450,
	"./football.webp": 1451,
	"./games-active.webp": 1452,
	"./games.webp": 1453,
	"./information.webp": 1454,
	"./live-streaming-cover.webp": 1455,
	"./lv-active-bg.webp": 1456,
	"./video-bg.webp": 1457,
	"./video-icon.webp": 1458,
	"./vs.webp": 1459
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 460;